export const ADMIN_MENU = "ADMIN";
